import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faCalendarDay, faCalendarStar, faChartPieSimple, faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import { memo } from 'react';
import { Inline, Inset, Stack } from 'syf-component-library/ui/spacing';
import { getFormattedDate } from '../../../helpers/promotions-utils';
import useTranslation from '../../../hooks/use-translation';
import { StyledFlex } from '../../../styles/common';
import TransactionDetail from '../../common/transaction-detail';
import PromotionsTooltip from '../tooltip';
import { StyledContentHeading } from './subcomponents';
const Details = ({ promotion }) => {
    const t = useTranslation();
    const purchaseDate = getFormattedDate({
        date: promotion.purchaseDate,
        monthFormat: 'MMMM'
    });
    const expirationDate = getFormattedDate({
        date: promotion.expirationDate,
        expirationDateLabel: t('promotions.untilPaidOffCellValue'),
        monthFormat: 'MMMM'
    });
    const details = [
        {
            detail: promotion.description,
            heading: t('promotions.detailsSpecialTermsLabel'),
            icon: faCalendarStar,
            title: 'detailsSpecialTermsLabel'
        },
        {
            detail: purchaseDate,
            heading: t('promotions.detailsPurchaseDateLabel'),
            icon: faCalendarDay,
            title: 'detailsPurchaseDateLabel'
        },
        {
            detail: `$${promotion.purchaseAmount}`,
            heading: t('promotions.detailsPurchaseAmountLabel'),
            icon: faDollarSign,
            title: 'detailsPurchaseAmountLabel'
        },
        {
            detail: expirationDate,
            heading: t('promotions.detailsExpirationDateLabel'),
            icon: faCalendarDay,
            title: 'detailsExpirationDateLabel'
        },
        {
            detail: `$${promotion.unbilledInterest}`,
            heading: t('promotions.detailsDeferredInterestChargesLabel'),
            icon: faDollarSign,
            title: 'detailsDeferredInterestChargesLabel'
        },
        {
            detail: `$${promotion.remainingBalance}`,
            heading: (_jsxs(StyledFlex, { children: [_jsx("span", { children: t('promotions.detailsPromotionalBalanceLabel') }), _jsx(Inline, { size: "small" }), _jsx(PromotionsTooltip, {})] })),
            icon: faChartPieSimple,
            title: 'detailsPromotionalBalanceLabel'
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), _jsx(StyledContentHeading, { as: "h4", size: "large", weight: "light", children: t('promotions.detailsPromotionDetailsHeading') }), _jsx(Inset, { horizontal: "large", children: _jsx("dl", { children: details.map(props => (_jsx(TransactionDetail, Object.assign({ translationObject: "promotions" }, props), props.title))) }) })] }));
};
export default memo(Details);
//# sourceMappingURL=index.js.map